<template>
  <div>
    <!-- <span>cambiandooo aaa{{ cambioTorneo }}</span> -->
    <config-acumulada
      :listCampeonatos="listCampeonatos"
      :categoria="idCategoriaSeleccionada"
      @newConfigAcumulada="updateFijos($event)"
    ></config-acumulada>
    <config-reset-ta
      :listEtapas="listEtapasReset"
      :categoria="categoriaSeleccionada"
      :campeonato="campeonatoActivo"
      :idReset="etapaSeleccionada"
      :listCambios="listCambios"
      @exitoTa="
        getEtapasResetTa($event)
        updateResetTA($event)
      "
    >
    </config-reset-ta>
    <add-valor-fijo
      :valorFijo="valorFijo"
      :categoria="idCategoriaSeleccionada"
      @fijoAgregado="updateFijos($event)"
    ></add-valor-fijo>
    <add-tipo-alterno
      :listTipos="listTiposNoCategoria"
      :categoria="idCategoriaSeleccionada"
      @tipoAgregado="updateTiposAlternos($event)"
    ></add-tipo-alterno>
    <modal-etapas
      :listEtapas="listEtapas"
      :idCategoria="idCategoriaSeleccionada"
      :total="totEnCero"
      :idCampeonato="idCampeonato"
      @getModalidad="getModalidad($event)"
    ></modal-etapas>
    <add-institucion
      :institucion="institucionNueva"
      :institucionAuxiliar="institucionAuxiliar"
      :listAuditoria="listAuditoria"
      @recargar="recargarInsertado($event)"
      @recargarUpdate="recargarUpdate($event)"
      :idUser="USER().id_usuario"
    ></add-institucion>
    <add-categoria
      :disciplina="categoriaNueva"
      :listDisciplinas="listDisciplinas"
      @recargarCategorias="
        getListCategorias(
          $store.state.someVariables.torneoSeleccionado.id_torneo,
        )
      "
      :idUser="USER().id_usuario"
    ></add-categoria>
    <b-tabs pills>
      <b-tab title="Categorias" active>
        <b-button
          v-if="USER().rol === ROLES.SUPER"
          v-b-tooltip.hover.v-primary
          title="Crear Categoria"
          variant="flat-primary"
          class="btn-icon"
          @click="showNewCategoria"
        >
          <feather-icon size="22" icon="PlusSquareIcon" />
        </b-button>
        <b-overlay :show="showLoading" rounded="sm">
          <item-configuration
            :opcionesCal="listOpcCalificacion"
            v-for="(item, index) in listCategorias"
            :item="item"
            :index="index"
            :listAux="listCategoriasAux"
            :key="item.id_categoria"
            @getModalidad="getModalidad($event)"
            @newValorFijo="showNewValorFijo(item.id_categoria)"
            @showResetTa="getEtapasResetTa(item)"
            @newConfigAcumulada="showNewConfigAcumulada(item.id_categoria)"
            @newTipoAlterno="showNewTipoAlterno(item.id_categoria)"
            @recargarCategorias="
              getListCategorias(
                $store.state.someVariables.torneoSeleccionado.id_torneo,
              )
            "
            @update="updateArray($event)"
            @deleteFijo="deleteFijo($event)"
            @deleteTipoAlterno="deleteTipoAlterno($event)"
          >
          </item-configuration>
        </b-overlay>
      </b-tab>
      <b-tab title="Instituciones" @click="getInstituciones">
        <configuration-institucion
          :listInstituciones="listInstituciones"
          :showLoadingIns="showLoadingIns"
          :limpiarDerecha="limpiarDerecha"
          @nueva="setearNueva"
          @update="setearUpdate($event)"
          @limpiaDerecha="limpiandoDerecha($event)"
          @changeTorneo="getInstituciones"
        ></configuration-institucion>
      </b-tab>
      <b-tab title="Carnet">
        <carnet :listCategorias="listCategoriasSelect"></carnet>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
// import { onMounted, ref } from '@vue/composition-api'
// import Ripple from 'vue-ripple-directive'

import {
  BTabs,
  BTab,
  BOverlay,
  // BCardText,
  // BCard,
  // BSpinner,
  // BFormCheckbox,
  BButton,
  //   VBTooltip,
  // BRow,
  // BCol,
  // BListGroupItem,
  // BListGroup,
  // BInputGroup,
  // BInputGroupPrepend,
  // BFormInput,
  // BFormGroup,
  //   BTable,
  //   BMedia,
  //   BAvatar,
  VBTooltip,
  //   BBadge,
} from 'bootstrap-vue'
import {
  computed,
  onMounted,
  reactive,
  ref,
  watch,
  // xx
} from '@vue/composition-api'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import { URL, USER, ROLES } from '../../utils/variables'
import ItemConfiguration from './itemConfig.vue'
import AddInstitucion from './AddInstitucion.vue'
import AddCategoria from './AddCategoria.vue'
import ConfigurationInstitucion from './ConfigurationInstitucion.vue'
import Carnet from './Carnet.vue'
import modalEtapas from './ModalEtapas.vue'
import AddValorFijo from './AddValorFijo.vue'
import AddTipoAlterno from './AddTipoAlterno.vue'
import ConfigAcumulada from './ConfigAcumulada.vue'
import ConfigResetTa from './ConfigResetTa.vue'

export default {
  components: {
    // BCardText,
    BTabs,
    BTab,
    BOverlay,
    BButton,
    // BCard,
    // BRow,
    // BCol,
    // BInputGroup,
    // BFormInput,
    // BInputGroupPrepend,
    // BSpinner,
    // BFormGroup,
    // BFormCheckbox,
    // BCardActions,
    // BListGroupItem,
    // BListGroup,
    ItemConfiguration,
    AddInstitucion,
    // BButton,
    ConfigurationInstitucion,
    Carnet,
    modalEtapas,
    AddCategoria,
    AddValorFijo,
    AddTipoAlterno,
    ConfigAcumulada,
    ConfigResetTa,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const listCategorias = ref([])
    const listCategoriasAux = ref([])
    const listOpcCalificacion = ref([])
    const listCategoriasSelect = ref([])
    const listTiposNoCategoria = ref([])
    const listEtapasReset = ref([])
    const idCategoriaSeleccionada = ref(null)
    const idCampeonato = ref(null)
    const categoriaSeleccionada = ref({})
    const exsiteConfigTA = ref(false)
    // const listCategoriasUsadasNoUsadas = ref([])
    const listInstituciones = ref([])
    const listEtapas = ref([])
    const listAuditoria = ref([])
    const listDisciplinas = ref([])
    const listCampeonatos = ref([])
    const listCambios = ref([])
    const totEnCero = ref(0)
    const { getApi } = apiCall()
    const checkSub = ref(false)
    const showLoading = ref(false)
    const showLoadingIns = ref(false)
    const limpiarDerecha = ref(false)
    const institucionNueva = ref({})
    const categoriaNueva = ref({})
    const institucionAuxiliar = ref({})
    const campeonatoActivo = ref({})
    const etapaSeleccionada = ref(null)
    const valorFijo = ref({ descripcion: null, valor: null })
    const institucionData = reactive({
      id_institucion: null,
      nombre: '',
      apodo: '',
      email: '',
      telefono: '',
      facebook: '',
      presidente: '',
      vicepresidente: '',
    })
    const disciplinaSeleccionado = ref({
      label: 'Seleccione Disciplina',
      value: '',
    })

    // eslint-disable-next-line
    // () => store.getters['someVariables/getTorneoSeleccionado']

    function showNewValorFijo(idCategoria) {
      store.commit('someVariables/UPDATE_SHOW_NEW_VALOR_FIJO', true)
      idCategoriaSeleccionada.value = idCategoria
    }
    function showNewConfigAcumulada(idCategoria) {
      idCategoriaSeleccionada.value = idCategoria
      store.commit('someVariables/UPDATE_SHOW_CONFIG_ACUMULADA', true)
    }

    async function getModalidad(idCategoria) {
      listEtapas.value = []
      totEnCero.value = 0
      const path = `ApiConfiguration/getModalidad/${idCategoria}/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const response = await getApi(URL, path)
      listEtapas.value = response.modalidad
      totEnCero.value = response.total
      idCategoriaSeleccionada.value = response.idCategoria
      idCampeonato.value = response.idCampeonato
      store.commit('someVariables/UPDATE_SHOW_MODAL_ETAPAS', true)
      // console.log(listEtapas.value)
    }
    async function getTiposAlternosNoCategoria(idCategoria) {
      listTiposNoCategoria.value = []
      const path = `ApiConfiguration/getTiposAlternosNoCategoria/${idCategoria}`
      const response = await getApi(URL, path)
      listTiposNoCategoria.value = response.data
      store.commit('someVariables/UPDATE_SHOW_NEW_TIPO_ALTERNO', true)
      idCategoriaSeleccionada.value = idCategoria
    }
    async function getEtapasResetTa(item) {
      listEtapasReset.value = []
      campeonatoActivo.value = {}
      const path = `ApiConfiguration/getModalidadesEtapas/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}/${item.id_categoria}`
      const response = await getApi(URL, path)
      listEtapasReset.value = response.data
      campeonatoActivo.value = response.campeonato
      exsiteConfigTA.value = response.existe
      etapaSeleccionada.value = response.id_reset_amarilla
      listCambios.value = response.list_cambios
      store.commit('someVariables/UPDATE_SHOW_CONFIG_RESET_TA', true)
      categoriaSeleccionada.value = item
      // idCategoriaSeleccionada.value = idCategoria
    }
    function showNewTipoAlterno(idCategoria) {
      getTiposAlternosNoCategoria(idCategoria)
    }
    function limpiandoDerecha(event) {
      // console.log(event)
      limpiarDerecha.value = event
    }
    function setearNueva() {
      listAuditoria.value = []
      store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', true)
      institucionNueva.value = { ...institucionData }
      institucionAuxiliar.value = { ...institucionData }
      // console.log(institucionNueva.value)
    }

    async function getAuditoria(idInstitucion) {
      listAuditoria.value = []
      const path = `ApiConfiguration/getAuditoriaInstitucion/${idInstitucion}`
      const data = await getApi(URL, path)
      listAuditoria.value = data.data
    }
    function setearUpdate(item) {
      // console.log(item)
      institucionNueva.value = { ...item }
      institucionAuxiliar.value = { ...item }
      getAuditoria(item.id_institucion)
      store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', true)
    }
    function doListSelectDisciplina(data) {
      const listReturn = []
      data.forEach(element => {
        const obj = {
          label: `${element.disciplina}`,
          value: element.id_disciplina,
        }
        listReturn.push(obj)
      })
      return listReturn
    }
    async function getDisciplinas() {
      // listCategoriasUsadasNoUsadas.value = []
      // showLoadingEquipos.value = true
      disciplinaSeleccionado.value = { label: 'Seleccione Equipo', value: '' }
      const path = 'ApiConfiguration/getDisciplinas/'
      const data = await getApi(URL, path)
      listDisciplinas.value = doListSelectDisciplina(data.data)
      // institucionSeleccionada.value = item
      // institucionSeleccionadaAux.value = { ...item }
    }
    function showNewCategoria() {
      // store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', true)
      getDisciplinas()
      store.commit('someVariables/UPDATE_SHOW_NEW_CATEGORIA', true)
    }
    function doListCategoriasSelect(data) {
      const listReturn = []
      data.forEach(element => {
        const obj = {
          label: `${element.disciplina} ${element.categoria}`,
          value: element.id_categoria,
          equipos: element.equipos,
          id_disciplina: element.id_disciplina,
          tiene_juvenil: element.tiene_juvenil,
          tiene_clasificado: element.tiene_clasificado,
          carnet_novato: element.carnet_novato,
          carnet_juvenil: element.carnet_juvenil,
          carnet_clasificado: element.carnet_clasificado,
        }
        listReturn.push(obj)
      })
      return listReturn
    }
    async function getListCategorias(idTorneo) {
      showLoading.value = true
      listCategorias.value = []
      listCategoriasAux.value = []
      listOpcCalificacion.value = []
      const path = `ApiConfiguration/getCategorias/${idTorneo}`
      const data = await getApi(URL, path)
      // console.log(data)
      if (data.flag === 's') {
        listCategorias.value = data.data
        // listCategoriasAux.value = data.dataAux
        listCategoriasAux.value = JSON.parse(
          // eslint-disable-next-line
          JSON.stringify(listCategorias.value),
        )
        listOpcCalificacion.value = data.opciones_calificacion
        listCategoriasSelect.value = doListCategoriasSelect(data.data)
      } else {
        listCategorias.value = []
      }
      showLoading.value = false
    }
    function updateFijos(item) {
      const found = listCategorias.value.findIndex(
        // eslint-disable-next-line
        element => element.id_categoria === item.id_categoria,
      )
      // listInstituciones.value[found] = item
      // console.log(found)
      // console.log(listCategorias.value)
      listCategorias.value[found].valores_fijos.push(item)
      listCategoriasAux.value = JSON.parse(
        // eslint-disable-next-line
        JSON.stringify(listCategorias.value),
      )
    }
    function updateTiposAlternos(item) {
      const found = listTiposNoCategoria.value.findIndex(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.id_tipo_jugador_alterno ===
          // eslint-disable-next-line
          item.antiguo.id_tipo_jugador_alterno,
      )
      listTiposNoCategoria.value.splice(found, 1)
      const found2 = listCategorias.value.findIndex(
        // eslint-disable-next-line
        element => element.id_categoria === idCategoriaSeleccionada.value,
      )
      listCategorias.value[found2].tipos_en_categoria.push(item.agregado)
      listCategoriasAux.value = JSON.parse(
        // eslint-disable-next-line
        JSON.stringify(listCategorias.value),
      )
    }
    function updateResetTA(item) {
      const found2 = listCategorias.value.findIndex(
        // eslint-disable-next-line
        element => element.id_categoria === categoriaSeleccionada.value.id_categoria,
      )
      listCategorias.value[found2].tiene_reset_amarillas = item.tiene_reset_amarillas
    }
    function deleteFijo(item) {
      // console.log(item)
      const found = listCategorias.value.findIndex(
        // eslint-disable-next-line
        element => element.id_categoria === item.id_categoria,
      )
      const foundIDFIjo = listCategorias.value[found].valores_fijos.findIndex(
        // eslint-disable-next-line
        element => element.id_valor_fijo === item.id_valor_fijo,
      )
      // listInstituciones.value[found] = item
      // console.log(listCategorias.value)
      listCategorias.value[found].valores_fijos.splice(foundIDFIjo, 1)
      // listCategoriasAux.value = JSON.parse(s
      //   // eslint-disable-next-line
      //   JSON.stringify(listCategorias.value)
      // )
    }

    function deleteTipoAlterno(item) {
      // console.log(item)
      const found = listCategorias.value.findIndex(
        // eslint-disable-next-line
        element => element.id_categoria === item.id_categoria,
      )
      const foundIDFIjo = listCategorias.value[
        found
      ].tipos_en_categoria.findIndex(
        // eslint-disable-next-line
        element =>
          // eslint-disable-next-line
          element.id_categoria_tipos_alternos ===
          // eslint-disable-next-line
          item.id_categoria_tipos_alternos,
      )
      // listInstituciones.value[found] = item
      // console.log(listCategorias.value)
      listCategorias.value[found].tipos_en_categoria.splice(foundIDFIjo, 1)
      // listCategoriasAux.value = JSON.parse(s
      //   // eslint-disable-next-line
      //   JSON.stringify(listCategorias.value)
      // )
    }
    function updateArray() {
      listCategoriasAux.value = JSON.parse(JSON.stringify(listCategorias.value))
    }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    function transformCampeonatos(array, salida) {
      array.forEach(element => {
        const obj = {
          label: `${element.anio_inic} - ${element.anio_fin}`,
          value: element.id_campeonato,
          id_torneo: element.id_torneo,
          activo: element.activo,
        }
        salida.value.push(obj)
      })
    }
    watch(cambioTorneo, data => {
      getListCategorias(data.id_torneo)
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
    })
    function compare(a, b) {
      if (a.nombre < b.nombre) {
        return -1
      }
      if (a.nombre > b.nombre) {
        return 1
      }
      return 0
    }
    function insert(element, array) {
      array.push(element)
      array.sort(compare)
      return array
    }
    function update(array) {
      array.sort(compare)
      return array
    }
    function recargarInsertado(data) {
      insert(data, listInstituciones.value)
    }
    function recargarUpdate(item) {
      const found = listInstituciones.value.findIndex(
        // eslint-disable-next-line
        element => element.id_institucion === item.id_institucion,
      )
      listInstituciones.value[found] = item
      update(listInstituciones.value)
      store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', false)
    }
    async function getInstituciones() {
      // store.commit(
      //   'someVariables/UPDATE_UBICACION_ACTUAL',
      //   // eslint-disable-next-line
      //   UBICACIONES.INSTITUCIONES
      // )
      showLoadingIns.value = true
      listInstituciones.value = []
      limpiarDerecha.value = true
      const path = `ApiUsuario/getInstituciones/${cambioTorneo.value.id_torneo}`
      const data = await getApi(URL, path)
      if (data.flag === 's') {
        listInstituciones.value = data.data
      } else {
        listInstituciones.value = []
      }
      showLoadingIns.value = false
    }

    // function showNewInstitucion() {
    //   store.commit('someVariables/UPDATE_SHOW_NEW_INSTITUCION', true)
    // }
    onMounted(() => {
      getListCategorias(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
      transformCampeonatos(
        store.getters['someVariables/getTorneoSeleccionado'].campeonatos,
        // eslint-disable-next-line
        listCampeonatos,
      )
    })
    // eker1882anita
    return {
      listCategorias,
      listOpcCalificacion,
      checkSub,
      listInstituciones,
      // showNewInstitucion,
      institucionData,
      getInstituciones,
      listCategoriasSelect,
      showLoading,
      showLoadingIns,
      USER,
      recargarInsertado,
      setearNueva,
      setearUpdate,
      institucionNueva,
      institucionAuxiliar,
      limpiarDerecha,
      limpiandoDerecha,
      recargarUpdate,
      cambioTorneo,
      getModalidad,
      listEtapas,
      idCategoriaSeleccionada,
      categoriaSeleccionada,
      totEnCero,
      listAuditoria,
      listCategoriasAux,
      updateArray,
      showNewCategoria,
      categoriaNueva,
      listDisciplinas,
      ROLES,
      getListCategorias,
      showNewValorFijo,
      getEtapasResetTa,
      showNewTipoAlterno,
      valorFijo,
      updateFijos,
      updateTiposAlternos,
      deleteFijo,
      listTiposNoCategoria,
      deleteTipoAlterno,
      idCampeonato,
      showNewConfigAcumulada,
      listCampeonatos,
      listEtapasReset,
      campeonatoActivo,
      exsiteConfigTA,
      etapaSeleccionada,
      listCambios,
      updateResetTA,
      // getListCategoriasUsadasNoUsadas,
      // listCategoriasUsadasNoUsadas,
      // getEquiposInstitucion,
    }
  },
}
</script>
